import {createStore} from "effector";

export const $sectorsList = createStore({count: 0, data: []})
